import { AddQuestionBox } from 'component/question';
import { CLICK, component, demoFile, INPUT, story } from 'system/demo';

demoFile('component/question');

component('AddQuestionBox', AddQuestionBox, {}, [
    story('Add Question', [INPUT('add-question', 'What is the meaning of life?'), CLICK('Add Question')]),
]);
